import { render } from "./ContactInformations.vue?vue&type=template&id=6900e5c6"
import script from "./ContactInformations.vue?vue&type=script&lang=js"
export * from "./ContactInformations.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ContactInformations.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36ffa97d%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fstore%2Fdetails%2Fsetup%2FContactInformations.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__